import { render } from "./GTComponent.vue?vue&type=template&id=4310576a&scoped=true"
import script from "./GTComponent.vue?vue&type=script&lang=js"
export * from "./GTComponent.vue?vue&type=script&lang=js"

import "./GTComponent.vue?vue&type=style&index=0&id=4310576a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ft\\Coding\\GT Designer\\gtdesigner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4310576a"]])

export default __exports__